import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

export const CenterWiseReportDetailsGet = (fetchData: any) => {
    const data = {
        GetCenterWiseReportToken: fetchData,
    };
    const url = `${API_URL}PostCenterWiseReport`;
    return makeApiCall(url, data);
};
